module.exports = __webpack_public_path__ + "img/UWBprecise_localization.889c6c5f.png";